module.exports = __webpack_public_path__ + "img/deviceEn.f4298f98.png";